const STORAGE_KEY = 'ticketListState'

const COLUMN_NAME_TO_ID = {
  Placa: 'placa',
  'Reg. Empresarial': 'particularRegistration',
  'Data de Ocorrência': 'occurrenceDate',
  Descrição: 'description',
  Código: 'code',
  Gravidade: 'level',
  Responsável: 'owner',
  Local: 'address',
  Cidade: 'city',
  Estado: 'state',
  Órgão: 'organization',
  'Obs.': 'observations',
  Valor: 'totalValue',
  'Prazo Ind.': 'indicationDue',
  Pagamento: 'paymentDay',
  'Status Ind.': 'indicationStatus',
  Condutor: 'driver',
  'Envio Ind.': 'documentCreatedAt',
  Vencimento: 'updatedDue',
  Captura: 'createdAt',
  Status: 'paymentStatus',
  AIT: 'aitNumber',
}

const resolveSortFieldId = (stored) => {
  if (typeof stored.sortFieldId === 'string') return stored.sortFieldId
  if (typeof stored.sortField === 'string') {
    return COLUMN_NAME_TO_ID[stored.sortField] ?? stored.sortField
  }
  return null
}

const DATE_FILTER_KEYS = [
  'updatedDueMin',
  'updatedDueMax',
  'indicationDueMin',
  'indicationDueMax',
  'createdAtMin',
  'createdAtMax',
  'occurrenceDateMin',
  'occurrenceDateMax',
]

export const EMPTY_TICKET_LIST_STATE = {
  sortFieldId: null,
  sortAsc: true,
  filters: {},
  searchQuery: '',
  activeNavLink: '',
  filteredTicketTagIds: [],
}

const safeParse = (raw, fallback) => {
  if (!raw) return fallback
  try {
    return JSON.parse(raw)
  } catch {
    return fallback
  }
}

export const parseFilterDate = (value) => {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

const sanitizeFilters = (filters) => {
  if (!filters || typeof filters !== 'object') return {}

  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) acc[key] = value
      return acc
    }

    if (typeof value === 'string' && value !== '') {
      acc[key] = value
      return acc
    }

    return acc
  }, {})
}

export const loadTicketListState = () => {
  const stored = safeParse(sessionStorage.getItem(STORAGE_KEY), EMPTY_TICKET_LIST_STATE)

  const sortFieldId = resolveSortFieldId(stored)

  return {
    sortFieldId,
    sortAsc: stored.sortAsc !== false,
    filters: sanitizeFilters(stored.filters),
    searchQuery: typeof stored.searchQuery === 'string' ? stored.searchQuery : '',
    activeNavLink: typeof stored.activeNavLink === 'string' ? stored.activeNavLink : '',
    filteredTicketTagIds: Array.isArray(stored.filteredTicketTagIds)
      ? stored.filteredTicketTagIds.filter((id) => id != null)
      : [],
  }
}

export const saveTicketListState = (state) => {
  const payload = {
    sortFieldId: state.sortFieldId ?? null,
    sortAsc: state.sortAsc !== false,
    filters: sanitizeFilters(state.filters),
    searchQuery: state.searchQuery ?? '',
    activeNavLink: state.activeNavLink ?? '',
    filteredTicketTagIds: Array.isArray(state.filteredTicketTagIds)
      ? state.filteredTicketTagIds
      : [],
  }

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
}

export const clearTicketListState = () => {
  sessionStorage.removeItem(STORAGE_KEY)
}

export const getInitialDateFromFilters = (filters, key) => parseFilterDate(filters?.[key])

export { DATE_FILTER_KEYS, STORAGE_KEY, COLUMN_NAME_TO_ID }

export const withColumnIds = (columns) =>
  columns.map((column) =>
    column.name && COLUMN_NAME_TO_ID[column.name]
      ? { ...column, id: COLUMN_NAME_TO_ID[column.name] }
      : column,
  )
